function adjustColumnWidth(table) {
    if (isOverflow(table)) return
    const colgroup = table.querySelector('table colgroup')
    const colDefs = [...colgroup.querySelectorAll('col')]
    colDefs.forEach((col) => {
        const clsName = col.getAttribute('name')
        const cells = [...table.querySelectorAll(`td.${clsName}`), ...table.querySelectorAll(`th.${clsName}`)]
        // 忽略加了"leave-alone"类的列
        if (cells[0]?.classList?.contains?.('leave-alone')) {
            return
        }
        const widthList = cells.map((el) => {
            return el.querySelector('.cell')?.scrollWidth || 0
        })
        const max = Math.max(...widthList)
        // const padding = 20
        table.querySelectorAll(`col[name=${clsName}]`).forEach((el) => {
            el.setAttribute('width', max + 20)
        })
    })
    // 设置滚动
    const scrollingBody = table.querySelectorAll('div.is-scrolling-none')
    if (scrollingBody[0]?.classList?.contains?.('is-scrolling-none')) {
        scrollingBody[0].classList.remove('is-scrolling-none')
        scrollingBody[0].classList.add('is-scrolling-left')
        scrollingBody[0].style.overflowX = 'auto'
    }
}
// 内容是否溢出
function isOverflow(table) {
    const colgroup = table.querySelector('colgroup')
    const colDefs = [...colgroup.querySelectorAll('col')]
    const maxList = []
    colDefs.forEach((col) => {
        const clsName = col.getAttribute('name')
        const cells = [...table.querySelectorAll(`td.${clsName}`), ...table.querySelectorAll(`th.${clsName}`)]
        // 忽略加了"leave-alone"类的列
        if (cells[0]?.classList?.contains?.('leave-alone')) {
            return
        }
        const widthList = cells.map((el) => {
            return el.querySelector('.cell')?.scrollWidth || 0
        })
        const max = Math.max(...widthList)
        maxList.push(max + 20)
    })
    const tWidth = maxList
        .filter((ele) => Number.isFinite(ele))
        .reduce((pre, cur) => {
            return pre + cur
        }, 0)
    console.log(table.offsetWidth, tWidth)
    return table.offsetWidth > tWidth
}

export default {
    mounted(el) {
        setTimeout(() => {
            adjustColumnWidth(el)
        }, 300)
    },
    updated(el) {
        el.classList.add('r-table')
        setTimeout(() => {
            adjustColumnWidth(el)
        }, 300)
    }
}
